import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Capacitor / native detection. When true, this build is running inside a
// native Android (or iOS) shell — cookies from a third-party origin don't
// stick reliably, so we fall back to storing the access token in Capacitor
// Preferences (encrypted at rest on Android via EncryptedSharedPreferences)
// and sending it as an Authorization: Bearer header on every request.
const IS_NATIVE = typeof window !== "undefined"
    && !!window.Capacitor
    && typeof window.Capacitor.isNativePlatform === "function"
    && window.Capacitor.isNativePlatform();

let _cachedToken = null;

async function _getPrefs() {
    if (!IS_NATIVE) return null;
    try {
        const mod = await import("@capacitor/preferences");
        return mod.Preferences;
    } catch { return null; }
}

export async function saveMobileToken(token) {
    _cachedToken = token || null;
    const p = await _getPrefs();
    if (p) {
        if (token) await p.set({ key: "access_token", value: token });
        else await p.remove({ key: "access_token" });
    }
}

async function _loadMobileToken() {
    if (_cachedToken) return _cachedToken;
    const p = await _getPrefs();
    if (!p) return null;
    const { value } = await p.get({ key: "access_token" });
    _cachedToken = value || null;
    return _cachedToken;
}

export const api = axios.create({
    baseURL: API,
    withCredentials: !IS_NATIVE,  // cookies only on the web
});

if (IS_NATIVE) {
    api.interceptors.request.use(async (config) => {
        const token = await _loadMobileToken();
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
}

export const isMobileNative = () => IS_NATIVE;


// error formatter (avoids React-crash on 422 error arrays)
export function formatApiError(e) {
    const detail = e?.response?.data?.detail;
    if (detail == null) return e?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
            .filter(Boolean)
            .join(" · ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return JSON.stringify(detail);
}

export const inr = (n) => {
    if (n == null || Number.isNaN(Number(n))) return "—";
    const num = Number(n);
    const sign = num < 0 ? "-" : "";
    const abs = Math.abs(num);
    return sign + abs.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const inrWhole = (n) => {
    if (n == null || Number.isNaN(Number(n))) return "—";
    return Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const formatDate = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return iso;
        return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    } catch {
        return iso;
    }
};
